import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "bkm_tokens";

export const tokenStore = {
  get: () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || null;
    } catch {
      return null;
    }
  },
  set: (t) => localStorage.setItem(KEY, JSON.stringify({ access_token: t.access_token, refresh_token: t.refresh_token })),
  clear: () => localStorage.removeItem(KEY),
};

export const api = axios.create({ baseURL: API_BASE, timeout: 30000 });

api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t?.access_token) config.headers.Authorization = `Bearer ${t.access_token}`;
  return config;
});

let refreshing = null;
let onLogout = () => {};
export const setLogoutHandler = (fn) => {
  onLogout = fn;
};

async function refreshTokens() {
  const t = tokenStore.get();
  if (!t?.refresh_token) throw new Error("no_refresh");
  const { data } = await axios.post(`${API_BASE}/auth/refresh`, { refresh_token: t.refresh_token });
  tokenStore.set(data);
  return data;
}

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const noRefresh = /^\/auth\/(login|register|refresh|logout)/.test(original.url || "");
    if (status === 401 && !original._retry && !noRefresh) {
      original._retry = true;
      try {
        refreshing = refreshing || refreshTokens();
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        tokenStore.clear();
        onLogout();
      }
    }
    return Promise.reject(error);
  },
);

export const errCode = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (!e?.response) return "network_error";
  return "unknown_error";
};

export const formatXAF = (n, lang = "fr") =>
  `${new Intl.NumberFormat(lang === "en" ? "en-US" : "fr-FR").format(n || 0)} XAF`;
